<template>
    <td>
        <v-icon v-if="isProtected" small> mdi-lock </v-icon>
        <v-tooltip v-else-if="icon" top color="primary">
            <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on" @click.stop="$emit('cell-clicked')">{{ icon }}</v-icon>
            </template>
            <span>{{ value }}</span>
        </v-tooltip>
        <a v-else-if="link" :href="link" :target="linkNewtab ? '_blank' : '_self'">{{ value }}</a>
        <span v-else>
            {{ value }}
        </span>
    </td>
</template>

<script>

export default{
    name: "MappingsTableCellValue",

    props: {
        value : {
            type: String,
            default: ""
        },
        link:{
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: null
        },
        isUserConnected:{
            type: Boolean,
            default: false
        },
        isMappingProtected:{
            type: Boolean,
            default: false
        },
        linkNewtab: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isProtected(){
            return !this.isUserConnected && this.isMappingProtected;
        }
    }
}
</script>